/**
 * Google Places API initialization
 */

// Global callback function for Google Maps API
window.initGooglePlaces = function () {
  // Notify all components that Google Places API is ready
  window.dispatchEvent(new CustomEvent('google-places-ready'));
};

// Fallback check in case callback doesn't work
let checkAttempts = 0;
const maxAttempts = 50;

function fallbackCheck() {
  if (typeof google !== 'undefined' && google.maps && google.maps.places) {
    window.dispatchEvent(new CustomEvent('google-places-ready'));
  } else if (checkAttempts < maxAttempts) {
    checkAttempts++;
    setTimeout(fallbackCheck, 100);
  }
}

// Start fallback check after a short delay
setTimeout(fallbackCheck, 1000);
